<template>
  <div class="group-manage conmon-top micro-page">
    <el-container>
      <!--左侧分组-->
      <el-aside class="left-aside-type" width="220px">
        <div class="group-search">
          <el-input placeholder="请输入分组名称" v-model.trim="groupName" @keyup.enter.native="searchQrcodeType">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer"
              @click="searchQrcodeType"></i>
          </el-input>
        </div>
        <el-menu default-active="0" class="el-menu-vertical-demo"
          style="max-height: 850px;width:100%; border-right: none; overflow-y: auto;overflow-x:hidden;margin-bottom: 0;padding-bottom: 0"
          @open="handleOpen" @close="handleClose" text-color="#333" active-text-color="#333">
          <el-menu-item :class="item.choosen ? 'getIt' : ''" :index="index + ''" v-for="(item, index) in groups"
            :key="index" @click="chooseWepageType(index, item)">
            <div class="menu-btn" v-if="item.name !== '全部'">
              <i v-if="butsObj.edit_group" @click="editGroupTypeItem(item)" class="el-icon-edit" style="margin-right: 0"></i>
              <i v-if="butsObj.del_group" @click="deleteMircoPageGroupItem(item)" class="el-icon-close" style="margin-right: 0"></i>
            </div>
            <span class="menu-title" :title="item.name">{{ item.name }}</span>
          </el-menu-item>
          <div class="add-group-btn" @click="addGroup" v-if="butsObj.add_group">
            <i class="el-icon-circle-plus-outline" title="添加分组"></i>
          </div>
        </el-menu>
      </el-aside>
      <!--右侧列表-->
      <div style="padding:0;width: calc(100% - 220px)">
        <div class="base-input ovf-hd conmon-top" style="margin-bottom: 10px;">
          <el-collapse-transition>
            <div class="search-content common-search-formtype" style="line-height: 56px;border: none">
              <div class="demo-input-suffix" style="text-align: left;margin-left: 32px">
                公众号切换：
                <el-select @change="searchData" v-model="public_id" placeholder="请选择">
                  <el-option v-for="item in weChatOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-collapse-transition>
        </div>
        <div class="base-input ovf-hd" style="margin-bottom: 10px">
          <el-row class="search-title">
            <el-col :span="4" class="table-title">
              <i class="el-icon-search" style="font-weight: bold;"></i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col :span="20" class="text-align-right">
              <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
              <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
              <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
              <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
              <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
            </el-col>
          </el-row>
          <el-row class="search-content common-search-formtype" v-show="hide">
            <el-col class="text-align-left common-search-formtype search-input-group">
              <el-form :inline="true" :model="searchForm" class="search-content-item micro-page-content-form"
                style="margin-top: 0" label-width="85px">
                <el-form-item label="内部名称：" style="margin-bottom: 0;">
                  <el-input clearable @keyup.enter.native="searchLoad" placeholder="请输入内部名称"
                    v-model.trim="searchForm.admin_title"></el-input>
                </el-form-item>
                <el-form-item label="更新时间：" style="margin-bottom: 0;">
                  <el-date-picker class="micro-page-picker" style="width:350px!important;margin-top: 8px"
                    v-model="timePickerDate" type="daterange" @blur="verifyTime" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="状态：" style="margin-bottom: 0;">
                  <el-select v-model="searchForm.publish_status" placeholder="全部" style="margin-right: 10px;"
                    class="customer-manage-search-item safari-input-style">
                    <el-option v-for="item in statusOptions" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <el-row class="search-title common-table-top" style="padding-right:0;height:50px;">
          <el-col :span="4" class="table-title" style="height:50px;">
            <i class="el-icon-document" style="font-weight: bold;"></i>
            <span>数据列表</span>
          </el-col>
          <el-col :span="20" class="text-align-right safari-input-style" style="height:50px">
            <span style="margin-left: 20px">移到分组：</span>
            <el-select class="common-search-formtype" style="margin:0 10px 8px 0;vertical-align: middle!important;"
              v-model="scene_group" :disabled="checkAll" @change="confirmChooseGroupType" placeholder="请选择目标分组">
              <el-option v-for="item in queryGroups" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-button v-if="butsObj.add" class="add-btn btn-right" type="primary" size="small"
                       style="margin-left: 0"
              @click="qrcodeAdd">新建微页面</el-button>
          </el-col>
        </el-row>
        <!--数据列表-->
        <el-table v-if="showCustomer === true" key="tableData" id="tableData" ref="multipleTable" :data="tableData"
          class="table table-checkbox-style microTable" @selection-change="handleSelectionChange" v-loading="loading"
          border>
          <template slot="empty">
            <div class="newTableEmpty">暂无数据，去<span @click="qrcodeAdd">新建</span></div>
          </template>
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="scenename_varchar" label="内部名称" width="200">
            <template slot-scope="scope">
              <router-link class="" :to="{ path: '/home/micro-page-look' , query: { id: scope.row.id}}"
                style="cursor: pointer;color: #4882ff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                {{ scope.row.admin_title }}
              </router-link>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="scenename_varchar" label="公众号" width="200">
                        <template slot-scope="scope">
                          <div>{{ public[scope.row.public_id] }}</div>
                        </template>
                    </el-table-column> -->
          <el-table-column prop="update_time" label="最后更新时间" width="" sortable>
            <template slot-scope="scope">
              {{ scope.row.update_time | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="">
            <template slot-scope="scope">
              <span slot="reference" v-if="scope.row.publish_status === 0"><span class="pointGray"></span>草稿</span>
              <span slot="reference" v-else class=""><span class="pointGreen"></span>已发布</span>
            </template>
          </el-table-column>
          <el-table-column label="访次/人次/提交" prop="time_count" width="" sortable>
            <template slot-scope="scope">
              {{ scope.row.time_count }}/{{ scope.row.people_count }}/{{ scope.row.commit_count }}
            </template>
          </el-table-column>
          <el-table-column label="推广" align="center">
            <template slot-scope="scope">
              <!-- <div @click="showQRcode(scope.row.scene_url)" v-if="scope.row.publish_status === 1" style="cursor: pointer;">
                            <qriously :value="scope.row.scene_url" :size="100" style="margin-left: 0;" />
                            二维码
                          </div> -->
              <img v-if="scope.row.publish_status === 1&&butsObj.extension" @click="showQRcode(scope.row.scene_url)"
                src="/static/img/qrcode.png" width="30px">
              <div v-else>---</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="230">
            <template slot-scope="scope">
              <div v-if="butsObj.copy" class="op-link" @click="copyAcivityAction(scope.row.id)">
                复制
              </div>
              <router-link v-if="butsObj.details" :to="{ path: '/home/micro-page-look' , query: { id: scope.row.id, modelId: modelId }}">
                <div class="op-link">
                  查看
                </div>
              </router-link>
              <div v-if="scope.row.publish_status === 0&&butsObj.release_or_down" @click="publishThis(scope.row.id)" class="op-link">
                发布
              </div>
              <div class="op-link editColor" v-if="scope.row.publish_status === 0&&butsObj.edit" @click="toEdit(scope.row)">
                <div>
                  编辑
                </div>
              </div>
              <div v-if="scope.row.publish_status === 1&&butsObj.release_or_down" @click="offLine(scope.row.id)" class="op-link">
                下线
              </div>
              <router-link v-if="butsObj.statistics" :to="{ path: '/home/micro-page-data' , query: { id: scope.row.id}}">
                <div class="op-link">
                  统计
                </div>
              </router-link>
              <div class="op-link deleteColor" v-if="butsObj.del" @click="deleteItem(scope.row)">
                删除
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-foot" style="text-align: right">
          <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :page-size="limit" :current-page="page"
            layout="total, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </el-container>
    <!--添加微页面分组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="创建微页面分组" :visible.sync="adddialog" width="520px">
      <el-form ref="addForm" :model="addForm" :rules="rules">
        <el-form-item label="分组名称:" :label-width="addLabelWidth" prop="name">
          <el-input class="stockInput stockInputSpe" type="text" v-model.trim="addForm.name" auto-complete="off"
            placeholder="输入微页面分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="cancelAdd" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="submitForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑微页面分组弹窗-->
    <el-dialog class="cellDialog base-dialog" title="编辑微页面分组" :visible.sync="editdialog" width="520px">
      <el-form ref="editForm" :model="editForm">
        <el-form-item label="分组名称:" :label-width="addLabelWidth" prop="name">
          <el-input class="stockInput stockInputSpe" type="text" v-model.trim="editForm.name" auto-complete="off"
            placeholder="输入微页面分组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" @click="confirmEdit">确 定</el-button>
      </div>
    </el-dialog>
    <!--推广图片弹窗-->
    <el-dialog class="cellDialog base-dialog" title="推广微页面" :visible.sync="spreaddialog" width="620px">
      <el-input id="copyObj" class="qrcode-show-input" type="text" v-model.trim="qrCodeUrl" auto-complete="off"
        placeholder=""></el-input>
      <!--<p style="width: 100%; word-break: break-all;">-->
      <!--{{ qrCodeUrl }}-->
      <!--</p>-->
      <el-button class="dialog-confirm-btn" @click="getUrl" style="margin-left: 15px;color: #fff">复制链接</el-button>
      <qriously :value="qrCodeUrl" style="margin: 0 auto;text-align: center" :size="240" />
      <!-- <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button class="dialog-cancel-btn" @click="spreaddialog = false" style="margin-left: 20px" >关闭</el-button>
            </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { getWePagesList, getWechatPublicListForNode, publishWePage, copyWePage, getWePageGroupList, moveToWePageGroup, deleteWePage, addWePageGroup, editWePageGroup, deleteWePageGroup, deleteQrcode, getSourceData, ChooseGroup } from '@/api/customer.js'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: 'weixinManage',
  data () {
    return {
      public_id: '',
      modelId: '',
      public: [],
      weChatOptions: [],
      loading: true,
      formInline: {},
      timePickerDate: '',
      imgpath: '',
      spreadurl: '',
      date: '',
      title: '',
      queryGroups: [],
      tableData: [],
      customerData: [],
      scene_group: '',
      statusOptions: [
        {
          id: '',
          name: '全部'
        },
        {
          id: 1,
          name: '已发布'
        },
        {
          id: 0,
          name: '草稿'
        }
      ],
      cateOptions: [],
      showCustomer: true,
      limit: 10,
      totalCount: 0,
      adddialog: false,
      editdialog: false,
      spreaddialog: false,
      addForm: {
        name: ''
      },
      editForm: {
        name: ''
      },
      addLabelWidth: '80px',
      dialogType: 0,
      editId: '',
      editGroupTypeId: '',
      page: 1,
      hide: true,
      closeChoose: '收起筛选',
      searchForm: {
        admin_title: '',
        publish_status: '',
        start_time: '',
        end_time: '',
        group_id: ''
      },
      search: {
        admin_title: '',
        publish_status: '',
        start_time: '',
        end_time: '',
        group_id: '',
        public_id: ''
      },
      publishTime: '',
      groupName: '',
      newGroupName: '',
      groups: [],
      deleteArrayIds: [],
      checkAll: true,
      isHigher: false,
      createGroupType: 0,
      groupTypeIndex: 0,
      isDisabled: false,
      lastId: 0,
      allTerms: {},
      len: 0,
      qrCodeUrl: '',
      rules: {
        name: [
          { required: true, message: '请输入微页面分组名称', trigger: 'blur' }
        ]
      },
      isSort: true,
      butsObj: { // button按钮列表
        add_group: false,
        details: false,
        del: false,
        add:false,
        copy:false,
        edit:false,
        statistics:false,
        extension:false,
        release_or_down:false,
        edit_group: false,
        del_group: false,
        move_to_group: false
      }
    }
  },
  mounted () {
    this.load()
    this.loadMicroPage()
    this.getButtonsList()
  },
  computed: {
    Newitems () {
      let _this = this
      let Newitems = []
      if (_this.groupName === '') {
        return
      }
      _this.groups.map(function (item) {
        if (item.name.search(_this.groupName) != -1) {
          Newitems.push(item)
        }
      })
      return Newitems
    }
  },
  components: {
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    // 跳转编辑页面
    toEdit (item) {
      if (this.public_id === '') {
        _g.toastMsg('error', '请选择具体公众号')
        return
      }
      router.push({ path: '/home/micro-page-edit', query: { id: item.id, public_id: this.public_id, modelId: this.modelId } })
    },
    // 切换公众号
    searchData (val) {
      this.page = 1
      for (let item of this.weChatOptions) {
        if (item.id === val) {
          this.public_id = item.id
          this.search.public_id = item.id
          this.modelId = item.modelId
        }
      }
      this.load()
    },
    // 加载公众号
    loadWechatList () {
      getWechatPublicListForNode('1').then(res => {
        for (let item of res.data.data.list) {
          this.weChatOptions.push({
            id: item.id,
            name: item.nick_name,
            modelId: item.model_id
          })
          if (item.is_default === 1) {
            this.public_id = item.id
            this.search.public_id = item.id
            this.modelId = item.model_id
          }
          this.public[item.id] = item.nick_name
        }
        this.load()
      })
    },
    // 获取二维码地址
    getUrl () {
      let url = document.querySelector('#copyObj')
      url.select() // 选择对象
      document.execCommand('Copy')
    },
    // 提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          return false
        }
      })
    },
    searchLoad () {
      this.page = 1
      if (this.timePickerDate === null) {
        this.searchForm.start_time = ''
        this.searchForm.end_time = ''
      } else {
        this.searchForm.start_time = this.timePickerDate[0]
        this.searchForm.end_time = this.timePickerDate[1]
      }
      this.search = JSON.parse(JSON.stringify(this.searchForm))
      this.search.public_id = this.public_id
      this.load()
    },
    // 判断开始结束时间大小
    verifyTime () {
      if (Date.parse(new Date(this.timePickerDate[0])) > Date.parse(new Date(this.timePickerDate[1]))) {
        _g.toastMsg('error', '开始时间不能晚于结束时间')
      }
    },
    // 下线
    offLine (id) {
      this.$confirm('确认下线该微页面?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        publishWePage(id, 0).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '微页面下线成功')
            this.load()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
      })
    },
    // 发布
    publishThis (id) {
      this.$confirm('确认发布该微页面?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        publishWePage(id, 1).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '微页面发布成功')
            this.load()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
      })
    },
    // 打开看二维码大图
    showQRcode (url) {
      this.spreaddialog = true
      this.qrCodeUrl = url
    },
    // 复制
    copyAcivityAction (id) {
      copyWePage(id).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '复制微页面成功')
          this.load()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    qrcodeAdd () {
      if (this.public_id === '') {
        _g.toastMsg('error', '请选择具体公众号')
        return
      }
      router.push({ name: 'microPageAdd', query: { public_id: this.public_id, modelId: this.modelId } })
    },
    // 微页面预览
    preview (yl_url) {
      window.open(yl_url, 'blank')
    },
    // 查找微页面类型
    searchQrcodeType () {
      for (let i in this.groups) {
        this.groups[i].choosen = false
        for (let j in this.Newitems) {
          if (this.groups[i].id === this.Newitems[j].id) {
            this.groups[i].choosen = true
          }
        }
      }
    },
    // 点选微页面类型
    chooseWepageType (index, item) {
      this.groupTypeIndex = index
      this.search.group_id = item.id
      this.load()
    },
    // 确认移到分组
    confirmChooseGroupType () {
      moveToWePageGroup(this.scene_group, this.deleteArrayIds).then((res) => {
        if (res.data.code === 0) {
          this.load()
          this.scene_group = ''
          _g.toastMsg('success', '移动分组成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 全选
    handleSelectionChange (val) {
      this.deleteArrayIds = []
      for (let i in val) {
        this.deleteArrayIds.push(val[i].id)
      }
      if (parseInt(val.length) > 0) {
        if(this.butsObj.move_to_group) {
          this.checkAll = false
        } else {
          this.checkAll = true
        }
      } else {
        this.checkAll = true
      }
    },
    // 列表删除
    deleteItem (item) {
      this.$confirm('确认删除该微页面?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteWePage(item.id).then((res) => {
          if (res.data.code === 0) {
            this.load()
            _g.toastMsg('success', '微页面删除成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
      })
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange (page) {
      this.page = page
      this.load()
    },
    // 加载数据列表
    load () {
      this.loading = true
      getWePagesList(this.page, this.limit, this.search).then((res) => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
          this.openLoading()
        }
      })
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 加载微页面分组列表
    loadMicroPage () {
      getWePageGroupList().then((res) => {
        if (res.data.code === 0) {
          res.data.data.list.unshift({ id: '', name: '全部' })
          for (let item of res.data.data.list) {
            item.choosen = false
          }
          this.groups = res.data.data.list
        }
      })
    },
    // 请求分组类型数组(给select用)
    loadGroupTypes () {
      getWePageGroupList().then((res) => {
        if (res.data.code === 0) {
          this.queryGroups = res.data.data.list
        }
      })
    },
    // 左侧分组导航
    handleOpen (key, keyPath) {
    },
    handleClose (key, keyPath) {
    },
    // 收起筛选和展开筛选
    closeAndOpen () {
      if (this.hide === true) {
        this.closeChoose = '展开筛选'
        this.hide = false
      } else {
        this.closeChoose = '收起筛选'
        this.hide = true
      }
    },
    // 添加微页面分组
    addGroup () {
      this.adddialog = true
      this.addForm.name = ''
    },
    // 删除微页面分组
    deleteMircoPageGroupItem (item) {
      this.$confirm('确认删除该微页面分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteWePageGroup(item.id).then((res) => {
          if (res.data.code === 0) {
            this.loadMicroPage()
            this.loadGroupTypes()
            _g.toastMsg('success', '删除分组成功')
            this.adddialog = false
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
      })
    },
    // 编辑微页面分组
    editGroupTypeItem (item) {
      this.editdialog = true
      this.editForm.name = item.name
      this.editForm.id = item.id
    },
    confirmEdit () {
      editWePageGroup(this.editForm.name, this.editForm.id).then((res) => {
        if (res.data.code === 0) {
          this.loadMicroPage()
          _g.toastMsg('success', '编辑微页面分组成功')
          this.editdialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 添加微页面分组弹窗 确定
    confirmAdd () {
      addWePageGroup(this.addForm.name).then((res) => {
        if (res.data.code === 0) {
          this.loadMicroPage()
          this.loadGroupTypes()
          _g.toastMsg('success', '添加微页面分组成功')
          this.adddialog = false
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 关闭微页面分组弹窗
    cancelAdd () {
      this.adddialog = false
    }
  },
  created () {
    // this.load()
    this.loadMicroPage()
    this.loadGroupTypes()
    this.loadWechatList()
  }
}
</script>

<style scoped>
.el-menu-item .menu-btn {
  display: none;
  float: right;
}
.el-menu-item:hover .menu-btn {
  display: block;
}
.cellDialog {
  text-align: left;
}
.getIt {
  color: #ff5500 !important;
}
.green {
  color: #05b324;
}
.red {
  color: #ff2b2b;
}
.cancelCreate {
  float: right;
  margin-right: 10px;
  color: #ff7373;
  cursor: pointer;
}
.el-menu-vertical-demo {
  position: relative;
}
.group-search {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}
.el-radio-group {
  margin-top: -13px;
}
.text-align-left {
  text-align: left;
}
.text-align-right {
  text-align: right;
}
.table-title {
  text-align: left;
}
.el-input--prefix .el-input__inner {
  padding-left: 40px !important;
}
.group-manage {
  overflow-x: hidden;
}
</style>
